import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./horizontalScrollProduct.scss";
import { Link } from "react-router-dom";
import productStore from "../../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import categoryStore from "../../../store/categoryStore";

gsap.registerPlugin(ScrollTrigger);

const HorizontalScrollProduct = () => {
  const ProductStore = productStore();
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const slider = sliderRef.current;

    const updateScroll = () => {
      const scrollAmount = slider.scrollWidth - container.offsetWidth;

      gsap.to(slider, {
        x: -scrollAmount,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "top top",
          end: `+=${scrollAmount}`,
          scrub: true,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });

      ScrollTrigger.refresh(); // Refresh ScrollTrigger
    };

    updateScroll();
    window.addEventListener("resize", updateScroll);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      window.removeEventListener("resize", updateScroll);
    };
  }, [ProductStore.product]);

  return (
    <section className="product-gallery" ref={containerRef}>
      <div className="slider" ref={sliderRef}>
        {ProductStore.product && ProductStore.product.length > 0 ? (
          ProductStore.product
            .slice(0, 5)
            .map((item) => <ProductCard product={item} key={item._id} />)
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </section>
  );
};

const ProductCard = ({ product }) => {
  const CategoryStore = categoryStore();
  const [categoryName, setCategoryName] = useState();

  useEffect(() => {
    if (CategoryStore.category) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === product.categoryID &&
          setCategoryName(category.categoryName)
        );
      });
    }
  }, [CategoryStore.category]);

  const cardStyle = {};

  const hoverBgStyle = {
    backgroundImage: `url(${PRODUCT_IMAGE_URL}${product.productImages[1]})`,
  };

  return (
    <Link
      to={`/${categoryName}/${product.productName}/${product._id}/details`}
      className="product-card"
      style={cardStyle}
    >
      <div style={hoverBgStyle} className="bg-img" />
      <img
        src={`${PRODUCT_IMAGE_URL}${product.productImages[0]}`}
        alt={product.productName}
      />
      <div className="basic-details">
        <h2>{product.productName}</h2>
        <div
          to={`/${categoryName}/${product.productName}/${product._id}/details`}
          className="link"
        >
          View Details
        </div>
      </div>
    </Link>
  );
};

export default HorizontalScrollProduct;
